export default __webpack_public_path__ + "static/media/projetor.0f5122c3.png";